import React, {useState, useEffect} from 'react';
import classNames from "classnames";
import Menu from "./inc/menu";
import Layout from "../../components/Layout";
import {
	useDeleteEmailChangeRequestMutation,
	useResendEmailChangeRequestMutation,
	useUpdateMeMutation
} from "../../rtk-api/settings";
import {getMe,useGetMeQuery, getRunningQueriesThunk} from "../../rtk-api/auth";

import Link from "next/link";
import Spinner from "../../components/Spinner";
import {useGeneralStore} from "../../stores/general";
import {useUserStore} from "../../stores/users";
import {wrapper} from "../../store";
import {useRouter} from "next/router";
import timezones from 'timezones-list';
import {buildErrorObject, showError} from "../../helpers/utils";

export const getServerSideProps = wrapper.getServerSideProps(store => async ({req, params}) => {
	store.dispatch(getMe.initiate());
	await Promise.all(store.dispatch(getRunningQueriesThunk()));
	
	return {
		props: {},
	};
});

function Settings(props) {
	const router = useRouter()
	const [updateMe, {isLoading:isUpdateLoading, isSuccess: isUpdateMeSuccess}] = useUpdateMeMutation()
	const [deleteEmailChangeRequest] = useDeleteEmailChangeRequestMutation()
	const [resendEmailChangeRequest] = useResendEmailChangeRequestMutation()
	const [showPage, setShowPage] = useState(false)
	
	const { data: me, isLoading, isSuccess:isMeSuccess } = useGetMeQuery()
	const [user, setUser] = useState([]);
	const setGlobalMessage = useGeneralStore((state) => state.setGlobalMessage)
	const setShowGlobalLoading = useGeneralStore((state) => state.setShowGlobalLoading)
	
	const changeRequestEmail = useUserStore((state) => state.changeRequestEmail)
	const setChangeRequestEmail = useUserStore((state) => state.setChangeRequestEmail)
	const [errorList, setErrorList] = useState({});
	
	
	useEffect(() => {
		if (me?.data.status === 8) {
			router.push(process.env.NEXT_PUBLIC_ORIGINAL_URL + '/dashboard/social/finalize')
		} else if (me?.data.status === 9) {
			router.push(process.env.NEXT_PUBLIC_ORIGINAL_URL + '/dashboard/downgrade')
		} else {
			setShowPage(true)
		}
	}, []);
	
	
	useEffect(() => {
		if (isMeSuccess) {
			
			setUser(me?.data)
			
			if (me?.data.change_email_request) {
				setChangeRequestEmail(me?.data.change_email_request.email)
			}
		}
	}, [me]);
	
	useEffect(() => {
		setShowGlobalLoading(isLoading)
	}, [isLoading]);
	
	const [resendText, setResendText] = useState('Resend');
	const [resent, setResent] = useState(false);
	
	async function handleResendChangeEmailRequest() {
		if (!resent) {
			setResendText('Resent!')
			setResent(true)
			await resendEmailChangeRequest()
		}
	}
	
	async function handleCancelChangeEmailRequest() {
		setChangeRequestEmail(null);
		await deleteEmailChangeRequest()
	}
	
	async function updateSettings(e) {
		e.preventDefault()
		await updateMe({
			data: {
				email: user.email,
				name: user.name,
				timezone: user.timezone,
				settings_page_hash: 'general'
			}
		})
			.unwrap()
			.then((data) => {
				setGlobalMessage({
					success: true,
					message: "Settings Saved!"
				})
				
				if (data.change_email_request) {
					setChangeRequestEmail(user.email)
				}
			})
			.catch((data) => {
				setErrorList(buildErrorObject(data.status, data.data.errors))
			});
	}
	
	function setSetting(key, value) {
		setUser(user => ({
			...user,
			[key]:value
		}))
	}
	
	if (showPage) {
		return (
			<Layout title="Settings">
				<div className="App m-auto pb-20">
					{isMeSuccess &&
						<>
							<h1 className="md:container mx-auto md:flex text-4xl mb-4 px-2">Settings</h1>
							<div className="main md:container mx-auto md:flex px-2">
								<Menu page="general"/>
								<div className="content md:w-3/4">
									
									<div className="card">
										<div className="mb-10">
											<h2 className="text-3xl mb-2">General Settings</h2>
											<p className="text-gray-400">These are your general settings</p>
										</div>
										
										<form onSubmit={e => updateSettings(e)}>
											<div className="form-group mb-4 md:flex">
												<label className="block md:w-1/4 mt-2">Name</label>
												<div className="mb-2 md:w-3/4">
													<input
														className="form-text"
														placeholder="Enter name"
														type="text"
														defaultValue={user.name}
														onChange={e => {
															setSetting('name', e.target.value)
															setErrorList({})
														}}
													/>
													{showError('name', errorList)}
												</div>
											</div>
											
											<div className="form-group mb-4 md:flex">
												<label className="block md:w-1/4 mt-2">Email Address</label>
												<div className="mb-2 md:w-3/4">
													<input
														className="form-text"
														placeholder="Email Address"
														type="text"
														name="email"
														defaultValue={user.email}
														onChange={e => {
															setSetting('email', e.target.value)
															setErrorList({})
														}}
													/>
													{showError('email', errorList)}
													{changeRequestEmail &&
														<div className="alert alert-warning rounded text-sm">
															<span>
																Your email change request to <strong>{changeRequestEmail}</strong> is pending. Please confirm this request by clicking the link sent to this email address.
															</span>
															<div className="mt-4">
															<span
																className={classNames(
																	{'cursor-pointer': !resent},
																	{'font-medium': !resent}
																)}
																onClick={handleResendChangeEmailRequest}>
																{resendText}
															</span>
																&nbsp;&middot;&nbsp;
																<span
																	className="cursor-pointer font-medium"
																	onClick={handleCancelChangeEmailRequest}>
																Cancel Request
															</span>
															</div>
														</div>
													}
												</div>
											</div>
											
											{/*<div className="form-group mb-4 md:flex">*/}
											{/*	<label className="block md:w-1/4 mt-2">Timezone</label>*/}
											{/*	<div className="mb-2 md:w-3/4">*/}
											{/*		<select id="timezone" name="timezone" className="form-text" value={user.timezone}*/}
											{/*				onChange={e => setSetting('timezone', e.target.value)}>*/}
											{/*			{timezones.map((t, index) =>*/}
											{/*				<option defaultValue={t.tzCode} key={index}>{t.label}</option>*/}
											{/*			)}*/}
											{/*		</select>*/}
											{/*	</div>*/}
											{/*</div>*/}
											<div className="w-full text-right relative justify-end">
												
												{isUpdateLoading &&
													<div className="inline-block px-5 text-center mr-4">
														<Spinner/>
													</div>
												}
												
												<button type="submit" disabled={isUpdateLoading} className="btn btn-primary md:w-auto">
													{isUpdateLoading ? 'Saving...' : 'Save'}
												</button>
											</div>
										
										</form>
									</div>
									
									<div className="mb-10">
										<Link href="/settings/delete" legacyBehavior>
											<a className="text-red-500">Delete my account</a>
										</Link>
									</div>
								
								</div>
							</div>
						</>
					}
				</div>
			</Layout>
		);
	}
}

export default Settings;
